import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex'
import getAjax from "@/utils/request";
import store from "@/utils/store";
import Footer from '@/components/Footer'
import '@/assets/less/style.less'
import '@/assets/less/chat.less'
import '@/utils/defaultFunc.js'
import VuePhotoPreview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css'; // 引入默认皮肤样式
import VueLoadmore from 'vuejs-loadmore';
import Vue2TouchEvents from 'vue2-touch-events';

Vue.prototype.netCall = getAjax
Vue.component('Footer', Footer);

Vue.use(Vuex)
Vue.use(VuePhotoPreview);
Vue.use(VueLoadmore);
Vue.use(Vue2TouchEvents);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
  $('body').off();
  document.title = to.meta.title || '首页'
  next();
})